module.exports = __webpack_public_path__ + "img/ir.5ce127e4.svg";